export class Zip {
    ID: string;
    ZIP: string;
    CITY: string;
    COUNTRY: string;
    STATE: string;
    METRO_AREA: boolean;
    RENT_RATE_RETAIL: number;
    RENT_RATE_INDUSTRIAL: number;
    RENT_RATE_OFFICE: number;
    RISK: number;

    // Helper
    zipError: string;

    static parse(json: any): Zip {
        if (json) {
            const z = new Zip();
            z.ID = json.ID;
            z.ZIP = json.ZIP;
            z.CITY = json.CITY;
            z.COUNTRY = json.COUNTRY;
            z.STATE = json.STATE;
            z.METRO_AREA = json.METRO_AREA;
            z.RENT_RATE_RETAIL = json.RENT_RATE_RETAIL;
            z.RENT_RATE_INDUSTRIAL = json.RENT_RATE_INDUSTRIAL;
            z.RENT_RATE_OFFICE = json.RENT_RATE_OFFICE;
            z.RISK = json.RISK;

            return z;
        } else { return null; }
    }

    static parseArray(json: Array<any>): Array<Zip> {
        const arr = [];

        if (json)
            for (const j of json)
                if (j)
                    arr.push(Zip.parse(j));

        return arr;
    }

}
